
function invoke () {
  var ctx = this, args = arguments;
  return function (λ) { λ.apply(ctx, args); };
}


//
// Dropdown
//
// Provide nice-looking dropdown with useful hooks for controllers, but also
// basic input control in the background so we can use it for form submissions.
//

module.exports = function Dropdown ($host, config) {

  var openClass = 'is-open';
  var wedgeCompensation = 9; // px

  // Dom
  var $drawer  = $('[data-dropdown-drawer]',  $host);
  var $value   = $('[data-current-value]',    $host);
  var $options = $('[data-dropdown-options]', $host);
  var $items   = $('[data-dropdown-value]',   $host);

  // State
  var state = {
    value: config.initialValue || null
  };

  var callbacks = {
    selection: []
  };

  // Functions
  function open () {
    $drawer.height( $options.height() + wedgeCompensation );
    $host.addClass(openClass);
  }

  function close () {
    $drawer.height( 0 );
    $host.removeClass(openClass);
  }

  function choose () {
    var value = this.dataset.dropdownValue;
    var text  = this.textContent;

    setCurrent(value, text);
    callbacks.selection.map(invoke(value, text));
    close();
  }

  function setCurrent (value, text) {
    state.value = value;
    $value.text(text);
  }

  // Listeners
  $host.on('mouseenter', open);
  $host.on('mouseleave', close);
  $items.on('click', choose);

  // Interface
  return {
    getValue:    function () { return state.value; },
    onSelection: function (λ) { callbacks.selection.push(λ); }
  };

};

